import React from "react";
import PropTypes from "prop-types";
import IllustrationEstimatedMarketValue from "../../illustrations/IllustrationEstimatedMarketValue";
import Preview from "./LivePreview";
import { Blur } from "./styled/live-preview-estimated-market-value";

function LivePreviewEstimatedMarketValue({ title }) {
  return (
    <Preview
      illustration={<IllustrationEstimatedMarketValue />}
      title={title}
      subTitle={<Blur>$888,888</Blur>}
    />
  );
}

LivePreviewEstimatedMarketValue.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewEstimatedMarketValue;
